import React,{useState,useEffect} from "react";
import Skeleton from 'react-loading-skeleton'
import siteConfig from "../../config/site-config";
import { cloudfront_base_url } from '../../config/config'
import './PublicProfileSidebar.scss'
import AxiosServices from "../../networks/AxiosService";
import ApiUrlServices from "../../networks/ApiUrlServices";
const qs = require('query-string');
const PublicProfileSidebar = (props) => {
    const parsed = qs.parse(window.location.search);
    const [loading,setLoading] = useState(false);
    const [userProfileData,setUserProfileData] = useState('');
    const [userSocial,setUserSocial] = useState('');

    useEffect(()=>{
        setLoading(true);
        AxiosServices.get(ApiUrlServices.GET_USER_PROFILE_PUBLIC(parsed.id))
            .then((res)=>{
                setUserProfileData(res.data.data);
                setUserSocial(res.data.data.social_links);
                console.log(res.data.data);
                setLoading(false);
            })
            .catch(err=>{
                console.log(err);
                setLoading(false);
            })
    },[parsed.id]);

    return(
        <>
        <div className="profile-sidebar-card">
            <div onClick={()=>props.setProfileMenuOpen(!props.profileMenuOpen)} className="mobile-toggle-menu">
                <i className={props.profileMenuOpen?"bi bi-x-lg":"bi bi-list"} />
            </div>
            <div className="thumb">
                {loading ? <Skeleton count={1} height={"250px"} /> : <>
                    {userProfileData.profile_picture ?
                        <img src={`${cloudfront_base_url}${userProfileData.profile_picture}`} alt={userProfileData.name} />
                        :
                        <img src={siteConfig.default_avatar} alt={'s'} />
                    }
                </>}

                <div className="overly-text">
                    <div className="overly-text-full">
                        <h4 className="name">{userProfileData.name}</h4>
                        <span>{userProfileData.profile_title}</span>
                    </div>
                </div>
            </div>
            <div className="content-user-p">
                <div className="name-or-profile-title">
                    <h4 className="name">{userProfileData.name}</h4>
                    <span>{userProfileData.profile_title}</span>
                </div>
            {loading ? <Skeleton count={2} /> :
                <div className="social">
                    {userSocial?.facebook ?
                        <span><a className="facebook" href={userSocial.facebook} target='__blank'><i className="fab fa-facebook-f" ></i></a></span>
                        :null}
                    {userSocial?.twitter ?
                        <span><a className="twitter" href={userSocial.twitter} target='__blank'><i className="fa-brands fa-x-twitter"/></a></span>
                        :null}
                    {userSocial?.linkedin ?
                        <span><a className="linkedin" href={userSocial.linkedin} target='__blank'><i className="fa-brands fa-linkedin" /></a></span>
                        :null}
                </div>

            }
            </div>
            
        </div>
        </>
    )
}
export default PublicProfileSidebar;